import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JobCostCenter } from 'src/shared/api';
import { FormConfig } from 'src/shared/form-models/form-cva.component';

const costCenterFormConfig: FormConfig<
	JobCostCenter & { addAnother: boolean }
> = {
	id: [''],
	job: [''],
	code: [''],
	description: [''],
	milePostRange: ['', Validators.maxLength(30)],
	addAnother: [true],
};

@Component({
	template: `
		<form [formGroup]="form" fxLayout="column">
			<mat-form-field>
				<input
					matInput
					placeholder="Code"
					formControlName="code"
					required
				/>
				<mat-error>Required</mat-error>
			</mat-form-field>
			<mat-form-field>
				<input
					matInput
					placeholder="Description"
					formControlName="description"
					required
				/>
			</mat-form-field>
			<mat-form-field>
				<input
					maxlength="30"
					matInput
					placeholder="Mile Post Range"
					formControlName="milePostRange"
					required
				/>
			</mat-form-field>
			<div
				mat-dialog-actions
				fxLayout
				fxLayoutAlign="space-between center"
			>
				<mat-checkbox class="text-right" formControlName="addAnother"
					>Add Another</mat-checkbox
				>
				<div>
					<button mat-button mat-dialog-close color="warn">
						Cancel
					</button>
					<button
						mat-button
						[disabled]="form.invalid"
						color="primary"
						[mat-dialog-close]="form.value"
						type="submit"
					>
						Save
					</button>
				</div>
			</div>
		</form>
	`,
})
export class AddJobCostCenterDialogComponent {
	readonly form = this.fb.group(costCenterFormConfig) as FormGroup;
	constructor(private readonly fb: FormBuilder) {}
}
